import { eventsThemeColors } from "./eventsThemeColors";
export var bannerEventsTheme = {
    alert: {
        color: eventsThemeColors.faireMarket.lightBackground,
        textColor: eventsThemeColors.faireMarket.promoText
    }
};
